export const properties = {
  authToken: window.Liferay.authToken,
  cdnURL: window.Liferay.ThemeDisplay.getCDNBaseURL(),
  portalURL: window.Liferay.ThemeDisplay.getPortalURL(),
};
